<template>
	<div>
		<b-modal v-model="show" :title="productSaleInfo.productName +''+productSaleInfo.productCode" hide-footer
			size="lg">
			<div>
				<b-spinner variant="primary" class="spinStyle" v-show="showSpin" label="Text Centered"></b-spinner>
				<b-row v-if="!showSpin" style="margin-top:20px;">
					<b-col lg="5">
						<div class="productImg">
							<b-carousel id="carousel-1" v-model="slide" :interval="30000" controls indicators
								 @sliding-start="onSlideStart" 
								@sliding-end="onSlideEnd">
								<b-carousel-slide v-for="(img, index) in  productSaleInfo.images" :img-src="img"
									:key="index">
									</b-carousel-slide>
							</b-carousel>
						</div>
						<div class="videoWrap">
							<div class="videoWrapTitle">示范视频</div>
							<div v-for="(item,index) in productSaleInfo.demonstrationVideoList" :key="item">
								<video controls height="200px" width="300px" :src="'http://img.brighten-floriplant.cn/'+item"></video>
							</div>
						</div>
					</b-col>
					<b-col lg="7">
						<div class="productInfo">
							<b-card border-variant="light" title="产品信息">
								<b-card-text>
									品种名称：{{productSaleInfo.productName + ' ' + productSaleInfo.productCode}}
								</b-card-text>
								<b-card-text>
									种苗规格：{{'高度'+productSaleInfo.seedlingHeight+'cm，'+productSaleInfo.leavesNumber+'对叶'}}
								</b-card-text>
								<b-card-text>
									包装数量：{{productSaleInfo.pottingSeedling + productSaleInfo.unitName + '/' + productSaleInfo.pottingSeedlingUnit +'，'+(productSaleInfo.pottingSeedling == 0 ? 0:(parseInt(productSaleInfo.productPackageQuantity/productSaleInfo.pottingSeedling)))+''+ productSaleInfo.pottingSeedlingUnit + productSaleInfo.productPackageQuantity+productSaleInfo.unitName+'/箱'}}
								</b-card-text>
							</b-card>
							<b-card border-variant="light" title="特别通告">
								<b-card-text v-html="productSaleInfo.productOtherSpec" >
									<!-- {{ productSaleInfo.productOtherSpec }} -->
								</b-card-text>
							</b-card>
							<b-card border-variant="light" title="品种介绍">
								<b-card-text  v-html="productSaleInfo.productfeatures">
									<!-- {{ productSaleInfo.productfeatures }} -->
								</b-card-text>
							</b-card>
							<b-card border-variant="light" title="栽培技术">
								<b-card-text v-html="productSaleInfo.productCultivation">
									<!-- {{ productSaleInfo.productCultivation }} -->
								</b-card-text>
							</b-card>
							<b-card border-variant="light" title="常见问题">
								<b-card-text v-html="productSaleInfo.productCommonProblem">
									<!-- {{ productSaleInfo.productCommonProblem }} -->
								</b-card-text>
							</b-card>
							<b-card border-variant="light" title="关于售后">
								<b-card-text  v-html="productSaleInfo.afterService">
									<!-- {{ productSaleInfo.afterService}} -->
								</b-card-text>
							</b-card>
							<b-card border-variant="light" title="优惠政策">
								<b-card-text v-html="productSaleInfo.discountPolicy">
									<!-- {{ productSaleInfo.discountPolicy }} -->
								</b-card-text>
							</b-card>
							<b-card border-variant="light" title="PDF目录">
								<b-card-text v-html="productSaleInfo.productDesInfoPdfLinkList">
									<!-- {{ productSaleInfo.discountPolicy }} -->
								</b-card-text>
							</b-card>
							<b-card border-variant="light" title="病虫防治">
								<b-card-text v-html="productSaleInfo.productDesInfoDiseasePestControl">								
								</b-card-text>
							</b-card>
							<b-card border-variant="light" title="采后处理">
								<b-card-text v-html="productSaleInfo.productDesInfoPostHarvestProcessing">								
								</b-card-text>
							</b-card>
						</div>
					</b-col>
				</b-row>
			</div>
		</b-modal>

	</div>
</template>

<script>
	import api from '@/api/api';
	import search from '@/libs/search';
	import "@/style/global.css";
	export default {
		name: 'ProductDetail',
		data() {
			return {
				slide: 0,
				sliding: null,
				show: false,
				showSpin: false,
				productUuid: '',
				productDetailInfo: {
					product: {
						productName: '',
						mainImg: '',
						imgList: ['']
					}
				},
				productSaleInfo: {},
				customerManagerInfo: ''
			};
		},
		methods: {
			onSlideStart(slide) {
				this.sliding = true
			},
			onSlideEnd(slide) {
				this.sliding = false
			},
			showModal(product) {
				this.productSaleInfo = JSON.parse(decodeURIComponent(product));
				this.productUuid = this.productSaleInfo.productUuid;
				this.getProductDetailInfo();
				this.getProductDescriptiveInformation();
				this.show = true;
			},
			getProductDetailInfo() {
				this.showSpin = true;
				let data = {
					productUuid: this.productUuid,
					// distributionStationUuid: this.$api.getStationUuid()
				};
				this.showSpin = true;
				api.getProductInfo(data).then(res => {
					this.globalShow = true;
					this.showSpin = false;
					if (res.code === 0) {
						let productInfo = res.data.productDetail.product;
						let seedFarmInfo = res.data.productDetail.seedFarm;
						let mainCateInfo = res.data.productDetail.mainCategory;
						let subCateInfo = res.data.productDetail.subCategory;
						let brand = res.data.productDetail.brand;
						let serial = res.data.productDetail.serial;
						let unitObj = res.data.productDetail.unit;
						let packageObj = res.data.productDetail.package;
						let seedFarm = res.data.productDetail.seedFarm;
						let manager = res.data.productDetail.manager;
						this.productSaleInfo.images = [];
						if (productInfo.productFinishImageFile) {
							productInfo.productFinishImageFile = api.fileServer + JSON.parse(productInfo
								.productFinishImageFile).url.replace(/\\/g, '\/');
							this.productSaleInfo.images.push(productInfo.productFinishImageFile);
							this.productSaleInfo.productFinishImageFile = productInfo.productFinishImageFile;
						}
						if (productInfo.productSeedImageFile) {
							productInfo.productSeedImageFile = api.fileServer + JSON.parse(productInfo
								.productSeedImageFile).url.replace(/\\/g, '\/');
							this.productSaleInfo.images.push(productInfo.productSeedImageFile);
						}
						if (productInfo.productTraySeedImageFile) {
							productInfo.productTraySeedImageFile = api.fileServer + JSON.parse(productInfo
								.productTraySeedImageFile).url.replace(/\\/g, '\/');
							this.productSaleInfo.images.push(productInfo.productTraySeedImageFile);
						}
						if (productInfo.productPackImageFile) {
							productInfo.productPackImageFile = api.fileServer + JSON.parse(productInfo
								.productPackImageFile).url.replace(/\\/g, '\/');
							this.productSaleInfo.images.push(productInfo.productPackImageFile);
						}
						if (productInfo.productStandardImageFile) {
							productInfo.productStandardImageFile = api.fileServer + JSON.parse(productInfo
								.productStandardImageFile).url.replace(/\\/g, '\/');
							this.productSaleInfo.images.push(productInfo.productStandardImageFile);
						}
						//示范视频-产品视频
						this.productSaleInfo.demonstrationVideoList=[];
						let proDemonVideoList=[];
						let seedFarmVideoList=[];
						if(productInfo.demonstrationVideo){
							proDemonVideoList=productInfo.demonstrationVideo.split(',');
						}
						//示范视频-苗场视频
						if(seedFarmInfo.demoVideo){
							seedFarmVideoList=seedFarmInfo.demoVideo.split(',');
						}
						this.productSaleInfo.demonstrationVideoList=seedFarmVideoList.concat(proDemonVideoList);
						this.productSaleInfo.brandName = brand.brandName;
						this.productSaleInfo.subCategoryName = subCateInfo.subCategoryName;
						this.productSaleInfo.productName = productInfo.productName;
						this.productSaleInfo.productCode = productInfo.productCode;
						this.productSaleInfo.productIncreaseStepAmount = productInfo.productIncreaseStepAmount;
						this.productSaleInfo.unitName = unitObj.unitName;
						this.productSaleInfo.productSpec = productInfo.productSpec;
						this.productSaleInfo.packageName = packageObj.packageName;
						this.productSaleInfo.productCategoryFeature = productInfo.productCategoryFeature;
						//品种特征
					//	this.productSaleInfo.productfeatures = productInfo.productfeatures;
						//栽培技术
						// this.productSaleInfo.productCultivation = productInfo.productCultivation;
						// //优惠政策
						// this.productSaleInfo.discountPolicy = productInfo.discountPolicy;
						//特别通告
					//	this.productSaleInfo.productOtherSpec = productInfo.productOtherSpec;
						// //关于售后
						// this.productSaleInfo.afterService = productInfo.afterService;
						// //常见问题
						// this.productSaleInfo.productCommonProblem = productInfo.productCommonProblem;
						// 苗高
						this.productSaleInfo.seedlingHeight = productInfo.seedlingHeight;
						// 对叶数
						this.productSaleInfo.leavesNumber = productInfo.leavesNumber;
						//盘苗数
						this.productSaleInfo.pottingSeedling = productInfo.pottingSeedling;
					}
				});
			},
			getProductDescriptiveInformation(){
				api.getProductDescriptiveInformation({productUuid:this.productUuid}).then(res=>{
					if(res.code==0){
						this.productSaleInfo.productOtherSpec=res.data.productDesInfopOtherSpec;
						this.productSaleInfo.productfeatures=res.data.productDesInffeatures;
						this.productSaleInfo.productCultivation = res.data.productDesInfoCultivation;
						
						this.productSaleInfo.discountPolicy = res.data.productDesInfodiscountPolicy;
						
						this.productSaleInfo.afterService = res.data.productDesInfoafterService;
						
						this.productSaleInfo.productCommonProblem = res.data.productDesInfoCommonProblem;

						this.productSaleInfo.productDesInfoPdfLinkList = res.data.productDesInfoPdfLinkList;

                        this.productSaleInfo.productDesInfoDiseasePestControl = res.data.productDesInfoDiseasePestControl;	

						this.productSaleInfo.productDesInfoPostHarvestProcessing = res.data.productDesInfoPostHarvestProcessing;
						
					}
				})
			}

		},
		components: {

		}
	};
</script>

<style>
	.productImg .carousel {
		position: relative;
		width: 300px;
		height: 330px;
		/* border: 1px solid #a16e02; */
	}
	
	.productInfo .card-title {
		font-size: 16px;
		margin-bottom: 5px;
		color: #a16e02;
	}

	.productInfo .card-body {
		padding: 10px;
		font-size: 14px;
	}

	.modal-header .close {
		border: none;
	}

	.modal-header button:focus {
		outline: none;
	}

	.videoWrapTitle {
		font-size: 16px;
		margin-bottom: 5px;
		color: #a16e02;
	}

	.videoWrap {
		margin-top: 30px;
	}

	.productImg .img-fluid {
		width:auto !important;
		/*height: 330px !important;*/
	}
	.carousel-indicators li{
		background-color:#a16e02;
	}
	.productImg .carousel-item{
		height: 330px !important;
		line-height: 330px !important;
		text-align: center;
	}
	.productImg .d-block{
		display:inline-block !important;
	}
	.carousel-control-prev-icon{
		background-image:url('../../assets/left.png');
	}
	.carousel-control-next-icon{
		background-image:url('../../assets/right.png');
	}
</style>



// WEBPACK FOOTER //
// src/view/product/product-detail.vue